import { lazy } from "react";
// ===========================================================================
// Patient Geography Module — georreferenciación de pacientes.
//
// Mapa de burbujas por ZIP con la distancia de cada paciente a su centro
// asignado, y la distinción accionable del módulo: reasignables (hay otro
// centro más cerca) vs. aislados (viven lejos de todo → telehealth/outreach).
//
// Backend: api/geography (docs/modulos/GeoSistem/10_ENDPOINTS_GEOGRAPHY.md).
// Diseño:  docs/modulos/GeoSistem/UIUX_GEOGRAFIA_PACIENTES.md.
//
// Acceso: piloto restringido por allowlist de empleados
// (REACT_APP_GEOGRAPHY_EMPLOYEES) — el guard lo resuelve antes de renderizar.
//
// Lazy obligatorio: Leaflet pesa y no debe viajar en el bundle inicial.
// ===========================================================================
const GeographyGuardedRoute = lazy(() => import("./components/GeographyGuardedRoute"));

export const patientGeographyRoutes = [
  { path: "/patient-geography", element: <GeographyGuardedRoute /> },
];

// Utilidades públicas del módulo (colores de banda, formato de distancias).
export * from "./common/constants";
